module.exports = __webpack_public_path__ + "img/Blue-R-1@2x.ad0b7fef.png";